import styled from "styled-components";
import { errorColor, bodyColor, primaryColor, primaryColorHover } from "../../config/constants";

export const ChangePasswordForm = styled.form`
  margin: auto;
  width: 100%;
  max-width: 860px;
  padding: 15px;
  border-radius: 5px;
  background-color: #fff;
  box-shadow: 0 5px 15px rgb(0 0 0 / 10%);
  @media (max-width: 910px) {
    width: 85%;
  }
`;
export const TitleTextDiv = styled.div`
  display: flex;
  justify-content: flex-start;
  @media (max-width: 910px) {
    font-size: 14px;
  }
`;
export const TextDiv = styled.div`
  margin: 20px 0;
  display: flex;
  justify-content: center;
  @media (max-width: 910px) {
    font-size: 14px;
  }
`;
export const TitleP = styled.p`
  font-weight: bold;
`;
export const TextP = styled.p`
  text-align: left;
`;
export const DataDiv = styled.div`
  margin-top: 20px;
  display: flex;
  justify-content: space-around;
  @media (max-width: 910px) {
    flex-direction: column;
    align-items: center;
  }
`;
export const ColumnDataDiv = styled.div`
  display: flex;
  flex-direction: column;
  @media (max-width: 910px) {
    width: 220px;
  }
`;
export const InputDataDiv = styled.div`
  margin-bottom: 10px;
  display: flex;
  align-items: baseline;
  justify-content: flex-end;
  position: relative;
  @media (max-width: 910px) {
    flex-direction: column;
    align-items: flex-start;
  }
`;
export const Label = styled.label`
  margin-right: 15px;
  font-size: 14px;
  font-weight: ${({ fontWeight }) => (fontWeight ? fontWeight : "normal")};
`;
export const Input = styled.input`
  padding: ${({ padding }) => (padding ? padding : "5px 10px")};
  width: 200px;
  border: ${({ error }) => (error ? `1px solid ${errorColor}` : `1px solid ${bodyColor}`)};
  outline: none;
  border-radius: 5px;
  font-size: 14px;
`;
export const SaveDiv = styled.div`
  margin-top: 20px;
  display: flex;
  justify-content: center;
`;
export const SaveButton = styled.button`
  padding: 10px;
  width: 108px;
  border: none;
  border-radius: 5px;
  color: #fff;
  font-size: 14px;
  font-weight: bold;
  text-align: center;
  background-color: ${primaryColor};
  outline: none;
  cursor: pointer;
  transition: all 0.15s ease-in-out;
  &:hover {
    background-color: ${primaryColorHover};
  }
`;
